import { cx } from '@vizit/theme';

interface DialogFooterProps extends React.HTMLAttributes<HTMLDivElement> {}

function DialogFooter(props: DialogFooterProps) {
  const { className, ...other } = props;

  return <div className={cx('flex items-center justify-between gap-6 mt-16 mx-12 mb-12', className)} {...other} />;
}

export { DialogFooter };
